import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { TableRow } from '../util/table-row';
import { TableCell } from '../util/table-cell';

import { EditableTableService } from './editable-table.service';



export class EditableTableComponent implements OnInit {

   tableHeaders: string[] = [];
   tableRows: any[][] = [];
   tableRowsWithId: any[][] = [];
   canDeleteRows = true;
   canEditRows = true;
   canAddRows = true;

   addButtonLabel: string;
   editButtonLabel: string;
   saveButtonLabel: string;
   cancelButtonLabel: string;
   deleteButtonLabel: string;

   addIcon = 'fa fa-plus';
   editIcon = 'fa fa-pencil-square-o';
   saveIcon = 'fa fa-check';
   deleteIcon = 'fa fa-times';

   addButtonClass: string;
   editButtonClass: string;
   deleteButtonClass: string;

   trClass: string;
   tdClass: string;
   buttonsTdClass: string;
   class: string;
   dataType = [];

   errorClass = 'myerror';
   isRequired = true;
   requiredMessage = 'Campo Requerido';


   onSave = new EventEmitter<any>();
   onRemove = new EventEmitter<any>();

  service: EditableTableService;

  constructor(service: EditableTableService) {
    this.service = service;
  }

  ngOnInit() {
    if (this.tableRows.length > 0 || (this.tableRows !== undefined && this.tableRowsWithId.length === 0)) {
      this.service.createTable(this.tableHeaders, this.tableRows, this.dataType);
    } else if (this.tableRowsWithId.length > 0 || (this.tableRowsWithId !== undefined && this.tableRows.length === 0)) {
      this.service.createTableWithIds(this.tableHeaders, this.tableRowsWithId, this.dataType);
    }
  }

  addRow() {
    this.service.addRow();
  }

  editRow(selectedRow: TableRow) {
    this.service.editRow(selectedRow);
  }

  cancelEdition(selectedRow: TableRow) {
    this.service.cancelEdition(selectedRow);
  }

  saveRow(selectedRow: TableRow) {
    for (const cell of selectedRow.cells) {
      if (cell.content == null || cell.content === '') {
        return;
      }
    }
    this.service.saveRow(selectedRow);
    const dir = [];

    for (let i = 0; i < selectedRow.cells.length; i++) {
      dir.push(selectedRow.cells[i].content);
    }
    const obj = { id: selectedRow.id, cells: dir };

    this.onSave.emit(obj);
  }

  deleteRow(selectedRow: TableRow) {
    this.service.deleteRow(selectedRow);
    const dir = [];

    for (let i = 0; i < selectedRow.cells.length; i++) {
      dir.push(selectedRow.cells[i].content);
    }
    const obj = { id: selectedRow.id, cells: dir };

    this.onRemove.emit(obj);
  }

  checkTypeOf(value: any): string {
    if (typeof (value) === 'boolean') {
      return 'boolean';
    }
    return '';
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'nv-editable-table',
  template: `
          <table class="{{class}}">
              <thead>
                <tr>
                  <th *ngFor="let title of service.tableHeadersObjects">{{title.content}}</th>
                  <th *ngIf="canEditRows||canDeleteRows"></th>
                </tr>
              </thead>
              <tbody>
                <tr class="{{trClass}}" *ngFor="let row of service.tableRowsObjects">
                  <td class="{{tdClass}}" *ngFor="let cell of row.cells">
                    <span *ngIf="service.isEditing.indexOf(row) === -1 && checkTypeOf(cell.content) !== 'boolean'">{{cell.content}}</span>
                    <span *ngIf="service.isEditing.indexOf(row) === -1 && checkTypeOf(cell.content) == 'boolean'">
                      {{cell.content ? 'Activo' : 'Inactivo'}}
                    </span>
                    <div class="ui input" *ngIf="!(service.isEditing.indexOf(row) == -1) && checkTypeOf(cell.content) !== 'boolean' 
                     && !isRequired">
                      <input type="text" [(ngModel)]="cell.content" [name]="cell.content">
                    </div>
                    <div class="ui input requiredInput" [ngClass]="{errorClass: !cell.content && cell.touched}" *ngIf="!(service.isEditing.indexOf(row) == -1) && checkTypeOf(cell.content) !== 'boolean' && isRequired">
                      <input type="text" [(ngModel)]="cell.content" [name]="cell.content" #[cell.content]="ngModel" required />
                        <div [ngClass]="{'show': !cell.content && cell.touched, 
                                  'hide': cell.content}" class="divmessage" style="Color: red;" [hidden]="cell.content">
                              <div>{{requiredMessage}}</div>
                          </div>
                        </div>
        <div *ngIf="!(service.isEditing.indexOf(row) == -1) && checkTypeOf(cell.content) === 'boolean'" class="field checkboxContainer">
            <div class="ui toggle checkbox">
                <input type="checkbox" name="public" [(ngModel)]="cell.content" name="active">
                <label>{{cell.content ? 'Activo' : 'Inactivo'}}</label>
            </div>
        </div>
                  </td>
                  <td class={{buttonsTdClass}} *ngIf="canEditRows||canDeleteRows">
                    <button class={{editButtonClass}} *ngIf="service.isEditing.indexOf(row) === -1 && canEditRows" (click)="editRow(row)">
                      <i class="{{editIcon}}"></i>{{editButtonLabel}}
                    </button>
                    <button class={{editButtonClass}} *ngIf="!(service.isEditing.indexOf(row) == -1) && canEditRows" 
                      (click)="saveRow(row)">
                      <i class="{{saveIcon}}"></i>{{saveButtonLabel}}
                    </button>
                    <button class={{deleteButtonClass}} *ngIf="canDeleteRows && service.isEditing.indexOf(row) === -1" 
                    (click)="deleteRow(row)">
                      <i class="{{deleteIcon}}"></i>{{deleteButtonLabel}}
                    </button>
                    <button class={{deleteButtonClass}} *ngIf="!(service.isEditing.indexOf(row) == -1) && canEditRows"
                     (click)="deleteRow(row)">
                      <i class="{{deleteIcon}}"></i>{{cancelButtonLabel}}
                    </button>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th *ngFor="let title of service.tableHeadersObjects"></th>
                  <th *ngIf="canEditRows||canDeleteRows">
                      <button class={{addButtonClass}} (click)="addRow()" *ngIf="canAddRows">
                          <i class="{{addIcon}}"></i>{{addButtonLabel}}
                      </button>
                  </th>
                </tr>
              </tfoot>
            </table>
  `,
  styles: [`tfoot{text-align: right;} 
  .myerror{color:red} 
  .requiredInput.divmessage{display:none} 
  .requiredInput.divmessage.show{display:block !important} 
  .requiredInput.divmessage.hide{display:none}`],
  providers: [EditableTableService]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: EditableTableService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'tableHeaders': [{ type: Input, args: ['table-headers', ] },],
'tableRows': [{ type: Input, args: ['table-rows', ] },],
'tableRowsWithId': [{ type: Input, args: ['table-rows-with-id', ] },],
'canDeleteRows': [{ type: Input, args: ['can-delete-rows', ] },],
'canEditRows': [{ type: Input, args: ['can-edit-rows', ] },],
'canAddRows': [{ type: Input, args: ['can-add-rows', ] },],
'addButtonLabel': [{ type: Input, args: ['add-button-label', ] },],
'editButtonLabel': [{ type: Input, args: ['edit-button-label', ] },],
'saveButtonLabel': [{ type: Input, args: ['save-button-label', ] },],
'cancelButtonLabel': [{ type: Input, args: ['cancel-button-label', ] },],
'deleteButtonLabel': [{ type: Input, args: ['delete-button-label', ] },],
'addIcon': [{ type: Input, args: ['add-icon', ] },],
'editIcon': [{ type: Input, args: ['edit-icon', ] },],
'saveIcon': [{ type: Input, args: ['save-icon', ] },],
'deleteIcon': [{ type: Input, args: ['delete-icon', ] },],
'addButtonClass': [{ type: Input, args: ['add-button-class', ] },],
'editButtonClass': [{ type: Input, args: ['edit-button-class', ] },],
'deleteButtonClass': [{ type: Input, args: ['delete-button-class', ] },],
'trClass': [{ type: Input, args: ['tr-class', ] },],
'tdClass': [{ type: Input, args: ['td-class', ] },],
'buttonsTdClass': [{ type: Input, args: ['buttons-td-class', ] },],
'class': [{ type: Input, args: ['class', ] },],
'dataType': [{ type: Input, args: ['data-type', ] },],
'errorClass': [{ type: Input },],
'isRequired': [{ type: Input },],
'requiredMessage': [{ type: Input },],
'onSave': [{ type: Output },],
'onRemove': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
